import {Component, Inject} from '@angular/core';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {LocalizationService} from '@npck/libs/commons';
import {appApplyTheme, UI_KIT_LIGHT} from '@npck/libs/ui-kit';
import dayjs from 'dayjs';
import {filter} from 'rxjs';
import {UserAttributesApiService} from '@npck/af-frontend-api';
import {AuthHolderService} from '../domain/auth-holder.service';
import {DictionaryHolderService} from '../domain/dictionary-holder.service';

@Component({
    selector: 'af-root',
    templateUrl: 'app.component.html',
    standalone: false
})
export class AppComponent {

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private localizationService: LocalizationService,
        @Inject(MAT_DATE_LOCALE) private locale: string,
        private dateAdapter: DateAdapter<any>,
        private dictionaryHolderService: DictionaryHolderService,
        private authHolderService: AuthHolderService,
        private userAttributesApi: UserAttributesApiService,
    ) {
        this.localizationService.init({
            languages: [
                {
                    locale: 'ru',
                    label: 'RU',
                }],
        });

        appApplyTheme(UI_KIT_LIGHT);
        this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/temp-cached/sprites/sprite-defs.svg`));
        this.localizationService.language$
            .pipe(filter(language => language !== null))
            .subscribe(language => {
                this.locale = language.locale;
                this.dateAdapter.setLocale(this.locale);
                dayjs.locale(language.locale);
                if (!this.authHolderService.isTokenExpired()) {
                    this.dictionaryHolderService.preloadCommonDictionaries();
                }
            });
        this.authHolderService.loadUserAttributes(this.userAttributesApi);
    }
}
